import { render } from "./ComCardExpand.vue?vue&type=template&id=143cac4c&scoped=true&ts=true"
import script from "./ComCardExpand.vue?vue&type=script&lang=ts"
export * from "./ComCardExpand.vue?vue&type=script&lang=ts"

import "./ComCardExpand.vue?vue&type=style&index=0&id=143cac4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143cac4c"]])

export default __exports__